import styled from 'styled-components'
import { useStoreParams } from '@/features/shared/utils/dataFetching/storeParams'
import { useUser } from '@/features/account/services/User/hooks'
import { useSession } from '@/features/authentication/utils/authentication/hooks/useSession'
import { AutocompletePill } from '@/features/shared/components/Headers/Header/styles'
import { Skeleton } from '@shipt/design-system-loading'

type Props = {
  className?: string
  children: React.ReactNode
}

export const SearchBarWrapper = ({ className, children }: Props) => {
  const user = useUser()
  const { isFullyAuthenticated } = useSession()
  const storeParams = useStoreParams()

  if (isFullyAuthenticated && !user) {
    return (
      <AutocompletePill>
        <Skeleton variant="circle" />
      </AutocompletePill>
    )
  }
  if (!storeParams.store_location_id) {
    return null
  }
  return <SearchBarWrapperElement className={className}>{children}</SearchBarWrapperElement>
}

export const SearchBarWrapperElement = styled.div`
  display: flex;
  width: 100%;
  border-radius: 999px;
  padding: 4px;
  background-color: ${({ theme }) => theme.color.background.base.neutral.subtle_100};
  border: none;

  &:focus-within {
    border: 2px solid ${({ theme }) => theme.primary};
    padding: 2px;
  }
`
